import GoodDataDashboard from "./GoodDataDashboard";
export { GoodDataDashboard };
